import { ReactElement } from 'react';

// ローディング表示
function Loading(): ReactElement {
  return (
    <div className="flex justify-center items-end absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 space-x-3">
      <div className="animate-ping h-4  w-1 bg-kotomilThemaColor rounded-full [animation-delay:100ms]" />
      <div className="animate-ping h-8  w-1 bg-kotomilThemaColor rounded-full [animation-delay:200ms]" />
      <div className="animate-ping h-6  w-1 bg-kotomilThemaColor rounded-full" />
      <div className="animate-ping h-8  w-1 bg-kotomilThemaColor rounded-full [animation-delay:900ms]" />
      <div className="animate-ping h-12 w-1 bg-kotomilThemaColor rounded-full [animation-delay:400ms]" />
    </div>
  );
}

export default Loading;
